import { UNLOCK_API_ENDPOINT } from '~/config.js';
import axios from 'axios';

const http = axios.create({
    baseURL: UNLOCK_API_ENDPOINT,
});

export async function getUserLockerData(tonconnectAddress) {
    const { data } = await http.get(`balance?address=${tonconnectAddress}`);

    return data;
}

export async function postCheckTx(boc) {
    const { data } = await http.post('checkTx', {
        boc,
    });

    return data;
}
